import { render, staticRenderFns } from "./TheCourseWellbeing.vue?vue&type=template&id=77fffd5a&scoped=true&"
import script from "./TheCourseWellbeing.vue?vue&type=script&lang=js&"
export * from "./TheCourseWellbeing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fffd5a",
  null
  
)

export default component.exports